import FadeUp from "./FadeUp";
import {
    Mail,
    Mic,
    BookOpen,
    Microscope,
    Workflow,
    ListChecks,
    PenLine,
    Zap,
    Files,
    Code2,
} from "lucide-react";

const categories = [
    { id: "email-calendar", icon: Mail, label: "AI Email & Calendar Tools" },
    { id: "meeting-assistants", icon: Mic, label: "AI Meeting Assistants" },
    { id: "knowledge-management", icon: BookOpen, label: "AI Knowledge Management" },
    { id: "research", icon: Microscope, label: "AI Research Tools" },
    { id: "agents-automation", icon: Workflow, label: "AI Agents & Workflow Automation" },
    { id: "project-task", icon: ListChecks, label: "AI Project & Task Management" },
    { id: "writing-content", icon: PenLine, label: "AI Writing & Content Creation" },
    { id: "personal-productivity", icon: Zap, label: "AI Personal Productivity" },
    { id: "document-management", icon: Files, label: "AI Document Management" },
    { id: "coding-agents", icon: Code2, label: "AI Coding Agents" },
];

export const TypesOfBrands = () => (
    <section
        id="types-of-brands"
        data-testid="types-of-brands-section"
        className="py-24 md:py-32 bg-white border-t border-black/[0.06]"
    >
        <div className="container-page">
            <div className="max-w-3xl">
                <FadeUp>
                    <h2
                        data-testid="types-of-brands-heading"
                        className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-[-0.02em] leading-[1.4] md:leading-[1.4] lg:leading-[1.4] text-[#0A0A0A] text-balance"
                    >
                        Types of Brands I Work With
                    </h2>
                </FadeUp>
                <FadeUp delay={0.08}>
                    <p className="mt-5 text-[15.5px] md:text-base text-gray-600 leading-[1.75] max-w-2xl">
                        I help AI-powered productivity and SaaS tools turn creator partnerships into a user acquisition channel.
                    </p>
                </FadeUp>
            </div>

            <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                {categories.map((c, i) => (
                    <FadeUp key={c.id} delay={0.04 + (i % 4) * 0.04}>
                        <div
                            data-testid={`types-of-brands-card-${c.id}`}
                            className="group h-full rounded-2xl border border-black/[0.08] bg-white p-5 md:p-6 hover:border-black/20 hover:-translate-y-0.5 transition-all flex flex-col items-start gap-4"
                        >
                            <div className="inline-flex items-center justify-center h-11 w-11 rounded-xl bg-[#FAFAFA] border border-black/[0.06] group-hover:bg-[#0A0A0A] transition-colors">
                                <c.icon className="h-5 w-5 text-[#0A0A0A] group-hover:text-white transition-colors" strokeWidth={1.8} />
                            </div>
                            <h3 className="font-display font-bold text-[15px] md:text-base tracking-tight text-[#0A0A0A] leading-[1.4]">
                                {c.label}
                            </h3>
                        </div>
                    </FadeUp>
                ))}
            </div>
        </div>
    </section>
);

export default TypesOfBrands;
